export default __webpack_public_path__ + "static/7_30-bc80b4abd268bb44344a147e9028c43b.png";